export default "__VITE_ASSET__D5MQ8n$X__"